import React from 'react';
import fetch from '../../fetch';
import utils from '../../../utils';
import {Tag} from 'antd'

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}


/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};


const getSelection =() => {
    return DataGrid.selections;
}

const headers = utils.columns([
    {type: 'selection'},
    {key:'$index', label: '序号' , width : 80},
    {key:'orgName', label: '部门名称',width : 120},
    {key:'majorName', label: '专业名称' ,width : 120},
    {key:'classesName', label: '班级名称' ,width : 120},
    {key:'studentName', label: '学生姓名' ,width : 120},
    {key:'studentNo', label: '学生学号' ,width : 120},
    {key:'graduationGrade', label: '届别' ,width : 120},
    {key:'masterName', label: '评审专家' ,width : 120},
    {key:'targetName', label: '审核指标' ,width : 120},
    {key:'title', label: '论文题目' ,width : 120},
    {key:'approvalStatus', label: '评审状态' ,width : 120 , render:(val)=>{
        if(val === 1){
            return <Tag color='#2db7f5'>审核通过</Tag>
        }else if(val === 2){
            return <Tag color='#f50'>审核不通过</Tag>}}},
    {key:'resultState', label: '提交状态' ,width : 120 , render:(val)=>{
        if(val === 1){
            return <Tag color='#2db7f5'>正式提交</Tag>
        }else if(val === 0){
            return <Tag color='#00FFFF'>预提交</Tag>}}},
    {key:'totalScore', label: '审核分数' ,width : 120},
    {key:'instructorName', label: '指导教师' ,width : 120},
    {key:'resultComment', label: '综合评语' ,width : 120},
    // {key:'norms', label: '学术规范' ,width : 120 , render:(val)=>{
    //     if(val === 1){
    //         return <Tag color='#f50'>发现问题</Tag>
    //     }else if(val === 2){
    //         return <Tag color='#2db7f5'>未发现问题</Tag>}}},
    {key:'termName', label: '学期' ,width : 120},
]);

const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    if(keywords['sort'] != '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('/graduation/master/result/query?' + params.join('&'), keywords)
    .then(response => {
        return {
            data: response.payload.data,
            meta: response.payload.meta,
        };
         
    })
    .then(response => 
        (Object.assign({
        result: response.data.dataList || [],
        selects: (response.data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: response.data.total,
        meta: response.meta,
        pageIndex: response.data.pageNum,
        pageSize: response.data.pageSize,
        notify: (response.data.dataList || []).length ? '' : '暂无数据...'
    })));
}

const getDetailById = (id)=> {
    return fetch.get(`graduation/result/getDetailById/${id}`)
}

const remove = (ids) => {
    return fetch.post('graduation/master/result/delete' , ids)
}

const update = (data) => {
    return fetch.post('graduation/result/update/'+data.id , data)
}

const get = (id) => {
    return fetch.get('graduation/master/result/get/'+id ) 
}

const batchSubmit = (ids) => {
    return fetch.post('graduation/master/result/batchSubmit', DataGrid.selections) 
}

const batchBack = (ids) => {
    return fetch.post('graduation/master/result/batchBack', DataGrid.selections ) 
}

export default {
    headers,
    get,
    batchSubmit,
    batchBack,
    onSelect,
    setRefresh,
    getSelection,
    querySearch ,
    getDetailById,
    delete : remove,
    update,
    download : `${fetch.base}graduation/result/file/download/`
}

